"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var mapStateToProps = function mapStateToProps(state) {
  return {
    loadingTokenValidate: state && state.auth && state.auth.retrieving,
    isAuthenticated: state && state.auth && state.auth.isAuthenticated
  };
};

var PrivateRoute =
/*#__PURE__*/
function (_ReactRouterRoute) {
  (0, _inherits2["default"])(PrivateRoute, _ReactRouterRoute);

  function PrivateRoute() {
    (0, _classCallCheck2["default"])(this, PrivateRoute);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PrivateRoute).apply(this, arguments));
  }

  (0, _createClass2["default"])(PrivateRoute, [{
    key: "render",
    value: function render() {
      if (this.props.loadingTokenValidate) {
        return _react["default"].createElement(_CircularProgress["default"], {
          centered: true,
          withPadding: true
        });
      }

      if (this.props.isAuthenticated) {
        return _react["default"].createElement(_reactRouterDom.Route, this.props);
      } else {
        var loginUrl = null;

        if (!this.props.loginUrl) {
          loginUrl = (0, _urlHelper.getLoginUrl)();
        } else {
          loginUrl = (0, _isFunction["default"])(this.props.loginUrl) ? this.props.loginUrl() : this.props.loginUrl;
        }

        window.location.href = loginUrl;
        return _react["default"].createElement(_CircularProgress["default"], {
          centered: true,
          withPadding: true
        });
      }
    }
  }]);
  return PrivateRoute;
}(_reactRouterDom.Route);

PrivateRoute.propTypes = {
  isAuthenticated: _propTypes["default"].bool,
  loadingTokenValidate: _propTypes["default"].bool,
  loginUrl: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func])
};
var component = (0, _reactRedux.connect)(mapStateToProps)(PrivateRoute);
var _default = component;
exports["default"] = _default;